// app/src/widgets/Sidebar/TopDonators.jsx
import React, { useState } from 'react';

const TopDonators = () => {
  const [activeTab, setActiveTab] = useState(1);

  const donatorsTab1 = [
    { name: 'Angranelined', amount: 5000 },
    { name: 'Makson77667', amount: 2555 },
    { name: 'Krauser Sub', amount: 2100 },
    { name: 'Ромарио Валерьянович', amount: 1000 },
    { name: 'Soma_Kruz', amount: 1000 },
    { name: 'DiaDiaWanya', amount: 1000 },
    { name: 'QStochek', amount: 1000 },
    { name: 'Kharas12', amount: 500 },
    { name: 'MasadaEX2', amount: 210 },
    { name: 'Алладин и Вертолет', amount: 100 },
  ];

  const donatorsTab2 = [
    { name: 'Angranelined', amount: 5000 },
    { name: 'Makson77667', amount: 1555 },
    { name: 'Krauser Sub', amount: 1000 },
    { name: 'Ромарио Валерьянович', amount: 1000 },
    { name: 'Soma_Kruz', amount: 1000 },
    { name: 'DiaDiaWanya', amount: 1000 },
    { name: 'QStochek', amount: 1000 },
    { name: 'Kharas12', amount: 500 },
    { name: 'MasadaEX2', amount: 130 },
    { name: 'Алладин и Вертолет', amount: 100 },
  ];

  return (
    <div className="donators-tabs" style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="tabs-header">
        <button className={`tab-btn ${activeTab === 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}>СУММА</button>
        <button className={`tab-btn ${activeTab === 2 ? 'active' : ''}`} onClick={() => setActiveTab(2)}>ОДИН</button>
      </div>

      <div className="tabs-content" style={{ flex: 1, overflowY: 'auto' }}>
        {(activeTab === 1 ? donatorsTab1 : donatorsTab2).map((donator, index) => (
          <div key={index} className="donator-item">
            <span className="donator-name">{donator.name}</span>
            <span className="donator-amount">{donator.amount} РУБ.</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopDonators;
